/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { Box, FormControlLabel, Typography } from 'src/components/UI'
import AntSwitch from 'src/components/UI/CustomUI/atoms/AntSwitch'
import TabNavigation from 'src/components/UI/CustomUI/organisms/TabNavigation'
import { employeeIsReadOnly } from 'src/ducks/selectors'
import EditView from './EditView'
import OCRReview from './OCRReview'
import OrderItems from './OrderItems'
import OrderItemsModal from './OrderItems/Modals'
import styles from './styles.module.scss'

const WorkOrder = ({ children }: { children: JSX.Element }) => {
  return (
    <Box sx={{
      border: '2px solid var(--border-color)',
      borderTop: 0,
      borderRadius: '0 0 0.75rem 0.75rem',
      paddingTop: '1rem',
      height: '100%',
      minHeight: '30vh'
    }}
    >
      {children}
    </Box>
  )
}

const WorkOrders = () => {
  const [mode, setMode] = useState({
    ocrMode: false,
    editMode: false
  })
  const [searchParams] = useSearchParams()
  const editModeFromParams = searchParams.get('editMode')
  const isReadOnly = useSelector(employeeIsReadOnly)
  const TABS: any = [
    {
      label: '',
      content: <WorkOrder><OrderItems /></WorkOrder>
    },
    {
      label: '',
      content: <WorkOrder><OCRReview /></WorkOrder>
    },
    {
      label: '',
      content: <WorkOrder><EditView /></WorkOrder>
    }
  ]

  useEffect(() => {
    if (editModeFromParams === 'true') {
      setTimeout(() => {
        setMode({ editMode: true, ocrMode: false })
      }, 1000)
    } else {
      setMode({ editMode: false, ocrMode: false })
    }
  }, [editModeFromParams])


  const getTab = () => {
    if (mode.ocrMode) return 1
    if (mode.editMode) return 2
    return 0
  }

  const handleOcrMode = () => {
    setMode({ editMode: false, ocrMode: !mode.ocrMode })
  }

  const handleEditMode = () => {
    setMode({ ocrMode: false, editMode: !mode.editMode })
  }

  return (
    <>
      <OrderItemsModal />
      <TabNavigation
        tabs={TABS}
        variant='outlined'
        margin={'0'}
        showExpand
        className={styles.Tabs}
        scrollable
        tabWidth='0'
        customExpanded={mode.ocrMode || mode.editMode}
        selectedTab={getTab()}
        additionalContent={
          <Box width='100%' display='flex' justifyContent="space-between" gap={2}>
            <Box display='flex' gap={2}>
              <FormControlLabel
                disabled={isReadOnly}
                label={<Typography marginRight={1} fontWeight={600}>OCR Mode</Typography>}
                labelPlacement='start'
                control={
                  <AntSwitch checked={mode.ocrMode} onChange={handleOcrMode} />
                }
              />
              <FormControlLabel
                disabled={isReadOnly}
                label={<Typography marginRight={1} fontWeight={600}>Edit Mode</Typography>}
                labelPlacement='start'
                control={
                  <AntSwitch checked={mode.editMode} onChange={handleEditMode} />
                }
              />
            </Box>
          </Box>
        }
        containerSx={{
          width: '96vw',
          marginTop: '3rem',
          gap: "1rem",
        }}
      />
    </>
  )
}

export default WorkOrders
